import { render, staticRenderFns } from "./AdminUserTransactionsElement.vue?vue&type=template&id=5ef7b334&scoped=true"
import script from "./AdminUserTransactionsElement.vue?vue&type=script&lang=js"
export * from "./AdminUserTransactionsElement.vue?vue&type=script&lang=js"
import style0 from "./AdminUserTransactionsElement.vue?vue&type=style&index=0&id=5ef7b334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef7b334",
  null
  
)

export default component.exports